import { render, staticRenderFns } from "./TameLegendSize.vue?vue&type=template&id=04190c5a"
import script from "./TameLegendSize.vue?vue&type=script&lang=js"
export * from "./TameLegendSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports